/**
 * Japon & Corée - Micro-interactions & Scroll Observer
 * Optimized for 60 FPS, Progressive Enhancement & prefers-reduced-motion
 */

(function () {
  'use strict';

  function initScrollAnimations() {
    if ('IntersectionObserver' in window) {
      const observerOptions = {
        root: null,
        rootMargin: '0px 0px -60px 0px',
        threshold: 0.12
      };

      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      const revealElements = document.querySelectorAll('.jk-reveal:not(.is-visible)');
      revealElements.forEach(el => revealObserver.observe(el));
    } else {
      // Fallback for older browsers
      const revealElements = document.querySelectorAll('.jk-reveal');
      revealElements.forEach(el => el.classList.add('is-visible'));
    }
  }

  // Handle Shopify Section Lifecycle & Dynamic Re-rendering
  document.addEventListener('DOMContentLoaded', initScrollAnimations);
  document.addEventListener('shopify:section:load', initScrollAnimations);
  document.addEventListener('shopify:section:select', initScrollAnimations);

  // In case of Turbo / View Transitions / SPA navigations
  window.addEventListener('pageshow', initScrollAnimations);
})();
